<template>
  <el-row type="flex" class="todo-customer">
    <el-col>
      <div class="todo-customer-id">
        {{ $t('idNumber') }}: {{ user.profile ? user.profile.id_number : ' ' }}
      </div>
      <div class="todo-customer-name">
        {{ user && user.profile ? user.profile.name : ' ' }}
      </div>
      <div class="todo-email">
        {{ user.email }}
      </div>
    </el-col>
    <el-col class="text-right col-right">
      <div class="todo-addresses">
        {{ user.profile ? user.profile.home_address : ' ' }}
      </div>
      <div class="todo-customer-phone">
        {{ user.profile ? user.profile.phone : ' ' }}
      </div>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    props: {
      user: Object
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/variables';

  .todo-customer {
    .col-right {
      width: 250px;
    }

    .todo-customer-id {
      font-size: 13px;
      color: $color-text-secondary;
    }

    .todo-customer-name {
      font-weight: 600;
      font-size: 18px;
      line-height: 34px;
      color: $color-text-regular;
    }

    .todo-email {
      /* */
    }

    .todo-addresses {
      font-size: 13px;
      line-height: 18px;
      color: $color-text-secondary;
    }

    .todo-customer-phone {
      /* */
    }
  }
</style>
